import { Star } from "lucide-react";
import { motion } from "framer-motion";

const TESTIMONIALS = [
  {
    name: "Mariana S.",
    relation: "Filha de paciente",
    text: "A Amparo & Aconchego trouxe paz para nossa família. A cuidadora é atenciosa, carinhosa e sempre nos mantém informados. Recomendo de olhos fechados.",
    stars: 5,
  },
  {
    name: "Roberto C.",
    relation: "Esposo de paciente",
    text: "Depois de muita pesquisa, encontramos o cuidado que minha esposa merecia. Profissionalismo e humanização de verdade, não só no discurso.",
    stars: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="section-padding gradient-warm">
      <div className="container">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-4 text-foreground">
          O que dizem sobre nós
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-xl mx-auto">
          Famílias reais que confiam no nosso cuidado.
        </p>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="bg-background rounded-xl p-8 shadow-sm border border-border"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, j) => (
                  <Star key={j} className="h-4 w-4 text-accent fill-accent" />
                ))}
              </div>
              <p className="text-foreground italic mb-6 leading-relaxed">"{t.text}"</p>
              <div>
                <p className="font-semibold text-foreground">{t.name}</p>
                <p className="text-sm text-muted-foreground">{t.relation}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
